var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.443 2H2v3.443h3.443V2zm8.491 8.033h-3.442v3.442h3.442v-3.442zM10.492 2h3.442v3.443h-3.442V2zm11.246 0h-3.443v3.443h3.443V2zM2 10.033h3.443v3.442H2v-3.442zm3.443 8.492H2v3.442h3.443v-3.442zM27.705 2.459H30v2.294h-2.295V2.46zM30 10.72h-2.295v2.296H30v-2.295zm-2.295 8.493H30v2.295h-2.295v-2.295zM30 27.475h-2.295v2.295H30v-2.295zM19.443 10.721h2.295v2.296h-2.295v-2.295zm2.295 8.493h-2.295v2.295h2.295v-2.295zm-2.295 8.262h2.295v2.295h-2.295v-2.295zm-6.197-8.262H10.95v2.295h2.296v-2.295zm-2.295 8.262h2.296v2.295H10.95v-2.295zm-5.966 0H2.689v2.295h2.294v-2.295z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFet);
export default __webpack_public_path__ + "static/media/FET.1d97c824e28eb8d274b02fb426ab9bbb.svg";
export { ForwardRef as ReactComponent };